// 视频可回溯功能，在main.js中引入即可
export default {
    start, stop, finish
}

import * as rrweb from "rrweb";
import { http_getOssSts ,http_saveSTSInsTracBack} from '../request/common'
import OSS from "ali-oss";
import moment from "moment";
// 用户id
let userId = undefined
// sessionId,第一次与后端交互的时间戳
let sessionId = undefined
let uuid = undefined

// 订单id
let bId = undefined

// 存储录制的数据
let data = []

// 等待上传的数据
let uploadData = []

// 上传数据的间隔时间，单位：秒
let intervalTime = 5
let interval = undefined

// 最大上传错误尝试次数，如果是-1，则不限次数
let maxErrorTimes = 20

// 停止录制方法
let stopRecod = undefined

// 正在进行http请求
let uploading = false

let startTime=""
let ossToken={}
let totalCount=0

/**
 * 开始录制可回溯视频
 * @param {String} userId 用户id
 */
function start(userId) {
    if (!userId) {
        return console.error('请传入userid')
    }

    init(userId)
    getOssToken()
    stopRecod = rrweb.record({
        emit(e) {
            data.push(e)
        },
        packFn: rrweb.pack,
        inlineStylesheet: false
    })
    startUpload()
}

//获取oss临时凭证
function getOssToken() {
    http_getOssSts().then(res=>{
       startTime=new Date().getTime()
       ossToken=res
    })
}
// 停止录制
function stop() {
    if (stopRecod) {
        stopRecod()
        clear()
    }
}

/**
 * 完成录制
 * @param {String} billId 订单id
 */
function finish(billId) {
    if (!billId) {
        return console.error('请传入订单id')
    }
    if (stopRecod) {
        stopRecod()
    }
    bId = billId
    // 立即上传剩下的所有数据
    // 如果定时器中的http请求正在执行，等待执行完毕，其方法内部会直接调用uploadAll方法
    // 如果定时器中的http没有在执行，直接清空定时器，执行uploadAll方法
    clearInterval(interval)
    uploadAll()
}

// uuid的BASE64格式
function getUuid() {
    return window.btoa(`${userId}+${Date.now()}+${navigator.userAgent}`)
}



// 开始执行数据上传
function startUpload(last=false) {
    let time = intervalTime
    interval = setInterval(async() => {
        time--
        if (time === 0) {
            if (data.length) {
                    if(!sessionId){
                        sessionId=new Date().getTime()
                    }
                    if(!ossToken||startTime+(30*60*1000)<new Date().getTime()){
                        getOssToken()
                    }
                    uploadAgain()
                    const sendOss={
                        region:ossToken.region,
                        authorizationV4: true,
                        stsToken:ossToken.stsToken,
                        accessKeyId:ossToken.accessKeyId,
                        accessKeySecret:ossToken.accessKeySecret,
                        bucket:ossToken.bucketName,
                        cname: true,
                        endpoint: ossToken.customDomain
                    }
                    const client=new OSS(sendOss)
                     let htmlData = JSON.stringify(JSON.parse(JSON.stringify(data)));
                    const file=new Blob([htmlData],{ type: "text/plain" })
                    const options={
                            headers: { "Content-Type": "text/plain" }
                    }
                    const fileName=`insTracBack/${moment(Number(sessionId)).format('YYYY-MM-DD').replace(/-/g, '')}/${uuid}/${Math.floor(100000 + Math.random() * 900000)}${new Date().getTime()}.txt`
                    totalCount=totalCount+1
                    client.put(fileName,file,options).then(res=>{	
                         // 清空录制数据存储对象
                        data = []	
                        time = intervalTime
                    }).catch(async ()=>{
                        let storeData=await localStorage.getItem('khsData')||"{}"
                        let allData={...JSON.parse(storeData),...{[fileName]:htmlData}}
                        localStorage.setItem('khsData',JSON.stringify(allData))
                        // 清空录制数据存储对象
                        data = []	
                        time = intervalTime
                        if(last){
                            uploadAgain()
                        }
                    })
            }else{
                time=intervalTime
            }
        }
    }, 1000)
}

async function  lastTimeUpload(){
        if(!sessionId){
            sessionId=new Date().getTime()
        }
        if(!ossToken||startTime+(30*60*1000)<new Date().getTime()){
            getOssToken()
        }
        uploadAgain()
        if(!data.length){
            return false
        }
        const sendOss={
            region:ossToken.region,
            authorizationV4: true,
            stsToken:ossToken.stsToken,
            accessKeyId:ossToken.accessKeyId,
            accessKeySecret:ossToken.accessKeySecret,
            bucket:ossToken.bucketName,
            cname: true,
            endpoint: ossToken.customDomain
        }
        const client=new OSS(sendOss)
        let htmlData = JSON.stringify(JSON.parse(JSON.stringify(data)));
        const file=new Blob([htmlData],{ type: "text/plain" })
        const options={
                headers: { "Content-Type": "text/plain" }
        }
        const fileName=`insTracBack/${moment(Number(sessionId)).format('YYYY-MM-DD').replace(/-/g, '')}/${uuid}/${Math.floor(100000 + Math.random() * 900000)}${new Date().getTime()}.txt`
        totalCount=totalCount+1
        client.put(fileName,file,options).then(res=>{	
             // 清空录制数据存储对象
            data = []	
            time = intervalTime
        }).catch(async ()=>{
            let storeData=await localStorage.getItem('khsData')||"{}"
            let allData={...JSON.parse(storeData),...{[fileName]:htmlData}}
            localStorage.setItem('khsData',JSON.stringify(allData))
            // 清空录制数据存储对象
            data = []	
            time = intervalTime
            uploadAgain()
        })
    }

async function uploadAgain() {
        let storeDataString=await localStorage.getItem('khsData')||"{}"
        let storeData=JSON.parse(storeDataString)
        if(!Object.keys(storeData).length){
            localStorage.removeItem('khsData')
            return false
        }
        const sendOss={
            region:ossToken.region,
            authorizationV4: true,
            stsToken:ossToken.stsToken,
            accessKeyId:ossToken.accessKeyId,
            accessKeySecret:ossToken.accessKeySecret,
            bucket:ossToken.bucketName,
            cname: true,
            endpoint: ossToken.customDomain
        }
        const options={
            headers: { "Content-Type": "text/plain" }
        }
        const client=new OSS(sendOss)
        for(let i in storeData){
            const file=new Blob([storeData[i]],{ type: "text/plain" })
            client.put(i,file,options).then(res=>{
                if(storeData[i]){
                    storeData=delete storeData[i]
                    localStorage.setItem('khsData',JSON.stringify(storeData))
                }
                
            })
        }
    }

// 立即上传剩下的所有数据
async function uploadAll(errortimes = 0) {
    // 把录制的数据放入待上传的数据中
    lastTimeUpload()
    await http_saveSTSInsTracBack({
        billId:bId,
        transNo: uuid,
        sessionId,
        fileCount:totalCount
    })
    setTimeout(()=>{
        localStorage.removeItem('khsData')
    },2000)
 
}



// 清除数据
function clear() {
    data = []
    uploadData = []
    sessionId = undefined
    uuid = undefined
    bId = undefined
    stopRecod = undefined
    totalCount=0
    if (interval) {
        clearInterval(interval)
    }
    interval = undefined
}

// 初始化
function init(uid) {
    console.log('init==============')
    clear()
    totalCount=0
    userId = uid
    uuid = getUuid()
    localStorage.removeItem('khsData')

}